// https://vuex.vuejs.org/en/state.html

export default {
  authStatus: '',
  token: localStorage.getItem('token') || '',
  user: localStorage.getItem('user') || '', //{}
  username: localStorage.getItem('username') || '',
  rolesuser: localStorage.getItem('rolesuser') || [],
  rolesuserid: localStorage.getItem('rolesuserid') || [],
  rolesid: localStorage.getItem('rolesid') || [],
  permisos: localStorage.getItem('permisos') || [],
  vencimiento: localStorage.getItem('validohasta') || null,
  foto: localStorage.getItem('foto') || '',
  idestado: localStorage.getItem('idestado') || 0,
  idsede: localStorage.getItem('idsede') || 0,
  mensaje: localStorage.getItem('mensaje') || '',
  idpersona: localStorage.getItem('idpersona') || 0,
  tableList: []
}
